import React from 'react';
import { spreads } from '../../config/spreads';
import SpreadCard from './SpreadCard';
import TarotTherapyBanner from './TarotTherapyBanner';
import SparklesIcon from '../../assets/icons/SparklesIcon';

const regularSpreads = spreads.filter((s) => !s.fullWidthBanner);
const bannerSpreads = spreads.filter((s) => s.fullWidthBanner);

const Spreads: React.FC = () => (
  <div
    className="container position-relative mt-3 py-4 py-xl-5"
    data-aos="fade"
  >
    <div className="row mb-5">
      <div className="col-md-8 col-xl-6 text-center mx-auto">
        <h2 className="fs-1 fw-bold text-primary">Видове подредби</h2>
        <p className="fw-bold text-primary w-lg-50">
          Изберете най-подходящото за Вас
        </p>
      </div>
    </div>

    {bannerSpreads.length > 0 && (
      <div className="row gy-4 mb-4" id="spreads">
        {bannerSpreads.map((spread) => (
          <TarotTherapyBanner
            key={spread.href}
            spread={spread}
            columnClassName={bannerSpreads.length > 1 ? 'col-12 col-md-6' : 'col-12'}
          />
        ))}
      </div>
    )}
    <hr className="my-5 w-75 mx-auto" />

    <div
      className="row gy-4 align-items-center align-items-xl-stretch gutter-y"
      id="spreads"
    >
      {regularSpreads.slice(0, 4).map((spread) => (
        <SpreadCard
          key={spread.title}
          spread={spread}
          columnClassName="col-12 col-md-6 col-xxl-3"
        />
      ))}
    </div>
    <hr className="my-5 w-75 mx-auto" />

    <div className="row gy-4 align-items-center align-items-xl-stretch gutter-y">
      {regularSpreads.slice(4, 6).map((spread) => (
        <SpreadCard
          key={spread.title}
          spread={spread}
          columnClassName="col-12 col-md-6"
        />
      ))}
    </div>
    <div className="row gy-4 align-items-center align-items-xl-stretch gutter-y" />
    <SparklesIcon />
  </div>
);

export default Spreads;
